<div class="badge-item">
  <div class="badge-container">
    <div class="badge-item-header">
      <span class="badge-title">{{ item.orgCode }}</span>
      <span class="badge-subtitle">{{ item.orgDescription }}</span>
    </div>
    <div class="badge-item-footer">
      <div class="flex-row">
        <div class="flex-1 footer-part">
          <span>{{ specialists }}</span>
          <label>{{ "responsible.item.specialistFunction" | translate }}</label>
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-1 footer-part">
          <span>{{ responsible }}</span>
          <label>{{ "responsible.item.executiveMemberShort" | translate }}</label>
        </div>
      </div>
    </div>
  </div>
</div>
